import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { avatarColor, cn, getInitials } from "@/lib/utils";

interface Props {
  name?: string | null;
  seed?: string | null;
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
}

const sizes = {
  sm: "size-8 text-xs",
  md: "size-10 text-sm",
  lg: "size-14 text-lg",
  xl: "size-20 text-2xl",
};

export function InitialsAvatar({ name, seed, size = "md", className }: Props) {
  const seedKey = seed ?? name ?? "?";
  return (
    <Avatar className={cn(sizes[size], className)}>
      <AvatarFallback className={avatarColor(seedKey)}>{getInitials(name)}</AvatarFallback>
    </Avatar>
  );
}
